import { Getters } from 'vuex-smart-module';
import ReportsServiceState from './state';

export default class ReportsServiceGetters extends Getters<ReportsServiceState> {}
